import React from "react";
import { createUseStyles } from "react-jss";
import { classNames } from "./utils/classNames";
import { setIcon } from "./utils/icons";
import { THEME } from "./theming/theming";
import { useIconClasses } from "./theming/icons";
import { Mode } from "./types";
export var TextStyleOptions;
(function (TextStyleOptions) {
    TextStyleOptions["Bold"] = "bold";
    TextStyleOptions["LineThrough"] = "lineThrough";
})(TextStyleOptions || (TextStyleOptions = {}));
export const BodyText = ({ message, glyph, className, glyphColor, disabled, lineThrough, mode = Mode.Light, textStyle, role, hideMessage, }) => {
    let { iconType, iconValue } = setIcon(glyph);
    const classes = useBodyTextClasses(disabled, lineThrough, mode, textStyle, hideMessage);
    const iconClasses = useIconClasses(iconType, mode === Mode.Dark ? THEME.palette.gray.white.color : glyphColor, hideMessage);
    if (iconType && iconValue) {
        return (React.createElement("span", { className: classNames(classes.bodyText, "body-text", className || ""), "aria-disabled": disabled ?? undefined, role: role ?? undefined },
            React.createElement("span", { className: classNames(iconClasses.icon, iconType, `${iconType}-${iconValue}`) }),
            React.createElement("span", { className: classNames("body-text--message", classes.message) }, message)));
    }
    return (React.createElement("span", { className: classNames(classes.bodyText, "body-text", className || ""), "aria-disabled": disabled ?? undefined, role: role ?? undefined }, message));
};
const BASE_BODY_TEXT = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    minHeight: 20,
    height: "100%",
};
const useBodyTextClasses = (disabled, lineThrough, mode, textStyle, hideMessage) => {
    const color = disabled
        ? THEME.palette.gray.smoke.color
        : mode === Mode.Dark
            ? THEME.palette.gray.white.color
            : THEME.palette.gray.slate.color;
    const useStyles = createUseStyles({
        bodyText: {
            ...BASE_BODY_TEXT,
            color,
            textDecoration: lineThrough || textStyle?.lineThrough ? "line-through" : null,
            fontWeight: textStyle?.bold ? 500 : null,
            "& a": {
                color,
                textDecoration: "underline",
            },
            "& a:hover": {
                color,
                textDecoration: "none",
            },
            "& p": {
                marginBottom: 0,
            },
        },
        message: {
            flex: 1,
            ...(hideMessage
                ? {
                    position: "absolute",
                    left: -10000,
                    top: "auto",
                    width: 1,
                    height: 1,
                    overflow: "hidden",
                }
                : {}),
        },
    });
    return useStyles();
};
